import { render, staticRenderFns } from "./OverallSpecialCharge.vue?vue&type=template&id=68a52852&"
import script from "./OverallSpecialCharge.vue?vue&type=script&lang=js&"
export * from "./OverallSpecialCharge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports